/**
 * ════════════════════════════════════════════════════════════
 *   LANDING V3 MASTER SCRIPT
 *   Optimized for Performance & Independence
 * ════════════════════════════════════════════════════════════
 */

(function() {
  'use strict';

  // Constants
  var DEFAULT_VARIANT = '51940113187118';
  var DEFAULT_PLAN    = '691610059054';

  /**
   * ─── FAQ TOGGLE (V2 PARITY) ───
   */
  function faq(el) {
    if (!el) return;
    var a = el.nextElementSibling;
    var c = el.querySelector('.faq-chev');
    if (!a || !c) return;
    
    var open = a.classList.contains('open');
    
    // Close all
    document.querySelectorAll('.faq-a').forEach(function(x) { x.classList.remove('open'); });
    document.querySelectorAll('.faq-chev').forEach(function(x) { x.classList.remove('open'); });
    
    // Open clicked if it wasn't open
    if (!open) { 
      a.classList.add('open'); 
      c.classList.add('open'); 
    }
  }

  /**
   * ─── LIGHTBOX LOGIC ───
   */
  var lb = {
    overlay: document.getElementById('lbOverlay'),
    iframe: document.getElementById('lbIframe'),
    cap: document.getElementById('lbCap'),
    
    open: function(src, title) {
      if (!this.overlay || !this.iframe) return;
      
      // Handle YouTube vs MP4
      if (src.includes('youtube.com') || src.includes('youtu.be')) {
        var ytId = src.split('v=')[1] || src.split('/').pop();
        this.iframe.src = 'https://www.youtube.com/embed/' + ytId + '?autoplay=1';
      } else {
        this.iframe.src = src;
      }
      
      if (this.cap) this.cap.textContent = title || '';
      this.overlay.classList.add('lb-open');
      document.body.style.overflow = 'hidden';
    },
    
    close: function() {
      if (!this.overlay) return;
      this.overlay.classList.remove('lb-open');
      if (this.iframe) this.iframe.src = '';
      document.body.style.overflow = '';
    }
  };

  /**
   * ─── AJAX CART HANDLER ───
   */
  function addSubscriptionToCart(variantId, sellingPlanId, button) {
    var vId, pId, btn;

    // Handle calls from event listeners (e.g. Hero buttons without inline onclick)
    if (variantId && typeof variantId === 'object' && variantId.preventDefault) {
      variantId.preventDefault();
      vId = DEFAULT_VARIANT;
      pId = DEFAULT_PLAN;
      btn = variantId.currentTarget;
    } else {
      // Direct calls from Liquid (e.g. onclick handlers)
      vId = variantId;
      pId = sellingPlanId;
      btn = button;
    }

    if (btn) {
      btn.classList.add('loading');
      var spinner = btn.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');
    }

    var item = { 'id': vId, 'quantity': 1 };
    if (pId) item.selling_plan = pId; // Only add if not null/empty

    var formData = { 'items': [item] };

    fetch(window.Shopify ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
    .then(function(response) { return response.json(); })
    .then(function(response) {
      // Direct redirect to checkout for V3
      window.location.href = '/checkout';
    })
    .catch(function(error) {
      console.error('Cart Error:', error);
      window.location.href = '/cart/' + vId + ':1?selling_plan=' + pId;
    })
    .finally(function() {
      if (btn) {
        btn.classList.remove('loading');
        var spinner = btn.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.add('hidden');
      }
    });
  }

  /**
   * ─── SCROLL ANIMATIONS ───
   */
  function initAnimations() {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
          // observer.unobserve(entry.target); // Keep observing if we want repeat
        }
      });
    }, { threshold: 0.15 });

    document.querySelectorAll('.animatable').forEach(function(el) {
      observer.observe(el);
    });
  }

  /**
   * ─── LAZY LOAD & AUTOPLAY VIDEOS (V2 PARITY) ───
   */
  function initLazyVideos() {
    let activated = false;
    function activate() {
      if (activated) return;
      if (window.scrollY > 200 || window.innerHeight > 800) {
        activated = true;
        document.querySelectorAll('.vidtest-card, .owner-video-thumb, .lazy-video-wrap').forEach(function(wrap) {
          var video = wrap.querySelector('video');
          if (!video) return;
          var source = video.querySelector('source');
          if (source && source.dataset.src) {
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
            video.load();
            video.style.display = 'block';
            var placeholder = wrap.querySelector('.owner-video-placeholder, .vidtest-video-placeholder');
            if (placeholder) placeholder.style.display = 'none';
            video.play().catch(function(){});
          }
        });
        window.removeEventListener('scroll', activate);
      }
    }
    window.addEventListener('scroll', activate);
    activate(); // check immediately
  }

  /**
   * ─── INITIALIZATION ───
   */
  document.addEventListener('DOMContentLoaded', function() {
    initAnimations();
    initLazyVideos();

    // Bind Lightbox
    document.querySelectorAll('.owner-video-thumb, .vidtest-thumb').forEach(function(el) {
      el.addEventListener('click', function() {
        var src = this.getAttribute('data-video-src');
        var title = this.getAttribute('data-title');
        if (src) lb.open(src, title);
      });
    });

    // Bind Lightbox Close
    var closeBtn = document.getElementById('lbClose');
    if (closeBtn) closeBtn.addEventListener('click', function() { lb.close(); });
    
    var lbOverlay = document.getElementById('lbOverlay');
    if (lbOverlay) lbOverlay.addEventListener('click', function(e) {
      if (e.target === lbOverlay) lb.close();
    });

    // Bind Global CTA buttons (those that don't use inline onclick)
    document.querySelectorAll('a.btn-coral, a.sub-btn, a.hsc-cta').forEach(function(btn) {
      if (!btn.hasAttribute('onclick')) {
        btn.addEventListener('click', addSubscriptionToCart);
      }
    });
  });

  // Global Exports
  window.addSubscriptionToCart = addSubscriptionToCart;
  window.faq = faq;

})();
